/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLocalPeeringGateway = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-4 2a4 4 0 0 1 7.874-1h6.252a4.008 4.008 0 0 1 1.858-2.455A4 4 0 1 1 15.127 13H8.873A4.002 4.002 0 0 1 1 12zm18-2a1.999 1.999 0 1 0 0 4 2 2 0 1 0 0-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLocalPeeringGateway as LocalPeeringGateway };
